const environment = {
  development: { baseURL: "https://zhangutech.com/prod-api" },
  // development: { baseURL: "http://220.180.76.126:8091" },
  production: { baseURL: "https://zhangutech.com/prod-api" },
};

export default environment[process.env.NODE_ENV];
